import { Skeleton } from "antd";
import { lazy, Suspense } from "react";

import { type HelpContent } from "@fitness-app/data-models/entities/HelpContent";

// Plate wchodzi osobnym chunkiem: dynamiczny import wystarczy, żeby Rollup go
// wydzielił — bez `manualChunks` w vite.config. Warunek odbioru: wejście na
// /dashboard i na listę centrum pomocy nie pobiera tego chunku.
const HelpArticleEditor = lazy(() => import("./HelpArticleEditor"));

interface HelpContentFieldProps {
  value: HelpContent;
  onChange: (value: HelpContent) => void;
}

export const HelpContentField = ({ value, onChange }: HelpContentFieldProps) => (
  <Suspense fallback={<Skeleton active paragraph={{ rows: 6 }} />}>
    <HelpArticleEditor value={value} onChange={onChange} />
  </Suspense>
);
